import React, { useState, useEffect } from 'react';
import AlertPopup from '../../../component/library/alertPopup';
import WebInput from '../../../component/library/webInput';
import WebButton from '../../../component/library/webButton';

export default function RestrictedWordsForm({ show, selectedWord, onClose, refreshList, handleSave, word, setWord, handleCancel }) {
    const [error, setError] = useState('');

    return (
        <AlertPopup
            modalIsOpen={show}
            setIsOpen={onClose}
            title={selectedWord ? 'Edit Restricted Word' : 'Add Restricted Word'}
            onClose={onClose}
        >
            <div style={{ padding: '20px' }}>
                <WebInput
                    label="Restricted Word"
                    placeholder="Enter the restricted word"
                    value={word}
                    onChange={(e) => setWord(e.target.value)}
                    error={error}
                />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                    <WebButton text="Cancel" onClick={handleCancel} className="cancel_btn" />
                    <WebButton text="Save" onClick={handleSave} className="success_btn" />
                </div>
            </div>
        </AlertPopup>
    );
}
